function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropableContainer, TitleComponent, EmptySearch, PropertiesTree, createTree, MousePositionedTooltip, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { useSearch, useKeypress } from '@keen.io/react-hooks';
import { Icon } from '@keen.io/icons';
import { colors } from '@keen.io/colors';
import { Container, PropertyOverflow, TitleWrapper, Subtitle, SubtitleIcon, TooltipMotionIconBold, TooltipContainer } from './TargetProperty.styles';
import PropertyPath from '../PropertyPath';
import { getEventPath } from '../../utils';
import { getCollectionSchema, getSchemas } from '../../modules/events';
import { SEPARATOR, NUM_ANALYSIS, NUM_ANALYSIS_MAP } from './constants';
import { AppContext } from '../../contexts';
import { BodyText } from '@keen.io/typography';

var TargetProperty = function TargetProperty(_ref) {
  var analysis = _ref.analysis,
      collection = _ref.collection,
      onChange = _ref.onChange,
      property = _ref.property,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'secondary' : _ref$variant,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expandTree = _useState2[0],
      setTreeExpand = _useState2[1];

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  var _useSelector = useSelector(function (state) {
    return getCollectionSchema(state, collection);
  }),
      collectionSchema = _useSelector.schema,
      schemaTree = _useSelector.tree,
      schemaList = _useSelector.list;

  var isSchemaExist = useSelector(function (state) {
    if (!collection) return false;
    if (collection && getSchemas(state)[collection]) return true;
    return false;
  });

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      propertiesTree = _useState4[0],
      setPropertiesTree = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isOpen = _useState6[0],
      setOpen = _useState6[1];

  var containerRef = useRef(null);
  var isAvailable = analysis && NUM_ANALYSIS.includes(analysis);

  var selectEventStreamTooltip = function selectEventStreamTooltip() {
    return React.createElement(BodyText, {
      variant: "body2",
      fontWeight: "normal",
      "data-testid": "select-event-stream-tooltip",
      color: colors.white[500]
    }, t('query_creator_target_property.select'), ' ', React.createElement("strong", null, t('query_creator_target_property.event_stream')), ' ', t('query_creator_target_property.first'));
  };

  var numericDataRequiredTooltip = function numericDataRequiredTooltip() {
    return React.createElement(BodyText, {
      variant: "body2",
      fontWeight: "normal",
      "data-testid": "numeric-data-required-tooltip",
      color: colors.white[500]
    }, t('query_creator_target_property.tooltip_start', {
      analysis: NUM_ANALYSIS_MAP[analysis]
    }), React.createElement(TooltipMotionIconBold, null, t('query_creator_target_property.tooltip_bold')), ' ', t('query_creator_target_property.tooltip_end'));
  };

  var _useSearch = useSearch(schemaList, function (searchResult, phrase) {
    if (phrase) {
      var searchTree = {};
      searchResult.forEach(function (_ref2) {
        var path = _ref2.path,
            type = _ref2.type;
        searchTree[path] = type;
      });
      setPropertiesTree(createTree(searchTree));
      setTreeExpand(true);
    } else {
      setTreeExpand(false);
      setPropertiesTree(null);
    }
  }, {
    keys: ['path', 'type'],
    threshold: 0.4
  }),
      searchHandler = _useSearch.searchHandler,
      searchPhrase = _useSearch.searchPhrase,
      clearSearchPhrase = _useSearch.clearSearchPhrase;

  useEffect(function () {
    if (isSchemaExist && !Object.keys(collectionSchema).includes(property)) {
      onChange(null);
    }

    return function () {
      return onChange(null);
    };
  }, [collection]);
  useEffect(function () {
    if (!isOpen) {
      setTreeExpand(false);
      clearSearchPhrase();
    }
  }, [isOpen]);
  var isEmptySearch = searchPhrase && propertiesTree && !Object.keys(propertiesTree).length;
  var keyboardHandler = useCallback(function (_e, keyCode) {
    if (keyCode === KEYBOARD_KEYS.ESCAPE) {
      setOpen(false);
    }
  }, []);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ESCAPE],
    addEventListenerCondition: isOpen,
    eventListenerDependencies: [isOpen]
  });
  return React.createElement(Container, {
    ref: containerRef
  }, React.createElement(TitleWrapper, null, React.createElement(TitleComponent, {
    isDisabled: !collection,
    onClick: function onClick() {
      return !isOpen && setOpen(true);
    },
    hasError: hasError
  }, t('query_creator_target_property.label')), React.createElement(MousePositionedTooltip, {
    isActive: isAvailable,
    tooltipTheme: "dark",
    tooltipPortal: modalContainer,
    renderContent: numericDataRequiredTooltip
  }, isAvailable && React.createElement(TooltipContainer, null, React.createElement(Subtitle, null, t('query_creator_target_property.subtitle'), React.createElement(SubtitleIcon, {
    "data-testid": "hint-icon-wrapper"
  }, React.createElement(Icon, {
    type: "info",
    fill: colors.blue['500']
  })))))), React.createElement(MousePositionedTooltip, {
    isActive: !collection,
    tooltipTheme: "dark",
    tooltipPortal: modalContainer,
    renderContent: selectEventStreamTooltip
  }, React.createElement("div", {
    "data-testid": "target-property-wrapper"
  }, React.createElement(DropableContainer, {
    hasError: hasError,
    variant: variant,
    onClick: function onClick() {
      return !isOpen && collection && setOpen(true);
    },
    isActive: isOpen,
    value: property,
    searchable: true,
    dropIndicator: true,
    searchPlaceholder: t('query_creator_target_property.search_placeholder'),
    placeholder: t('query_creator_target_property.placeholder'),
    onSearch: searchHandler,
    onDefocus: function onDefocus(event) {
      var _a;

      if (!((_a = getEventPath(event)) === null || _a === void 0 ? void 0 : _a.includes(containerRef.current))) {
        setPropertiesTree(null);
        setOpen(false);
      }
    }
  }, React.createElement(PropertyOverflow, null, property && React.createElement(PropertyPath, {
    path: property.split(SEPARATOR)
  }))))), React.createElement(Dropdown, {
    isOpen: isOpen
  }, isEmptySearch ? React.createElement(EmptySearch, {
    message: t('query_creator_target_property.empty_search_results')
  }) : React.createElement(PropertiesTree, {
    modalContainer: modalContainer,
    expanded: expandTree,
    onClick: function onClick(_e, property) {
      setOpen(false);
      onChange(property);
      setPropertiesTree(createTree(collectionSchema));
    },
    activeProperty: property,
    properties: propertiesTree ? propertiesTree : schemaTree
  })));
};

export default TargetProperty;